import React from 'react'
import ApplyStep from './ApplyStep'
import GenericIcon from 'components/GenericIcon'

const UsefulArticles = () => (
  <div className='useful-articles-container mt-5'>
    <div className='container'>
      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-12">
          <h4 className='useful-articles-header mb-3'>Useful articles</h4>
          <div className='useful-articles-sub-header'>Read our guides to help you get started</div>
          <a className='btn btn-lg btn-green mt-4 read-all-articles-pc' href="/resources" style={{width: '220px'}} >
            Read all articles
          </a>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-12 mb-5">
            <a className='useful-article' href="/resources/post/applying-for-a-home-loan-online">
              <div className='useful-article-text'>How to apply for a home loan online</div>
              <div className='useful-article-icon'><GenericIcon className='generic-icon' name='greenRightArrow' /></div>
            </a>
          
          <a className='useful-article' href="/resources/post/refinancing-home-loan">
            <div className='useful-article-text'>The what, why and how of refinancing home loans</div>
            <div className='useful-article-icon'><GenericIcon className='generic-icon' name='greenRightArrow' /></div>
          </a>
          <a className='useful-article' href="/resources/post/first-home-buyers-guide">
            <div className='useful-article-text'>Guide to buying your first home</div>
            <div className='useful-article-icon'><GenericIcon className='generic-icon' name='greenRightArrow' /></div>
          </a>
        </div>
        <a className='btn btn-lg btn-green mt-2 read-all-articles-mobile' href="/resources" >
          Read all articles
        </a>
      </div>
    </div>
  </div>
);

export default UsefulArticles
